module.exports = __webpack_public_path__ + "img/change.03d81ade.png";